import * as yup from 'yup';

export const messageSchemaFactory = () => {
  return yup.string().required('Message is required.');
};

export const emailShemaFactory = (name = 'Email') => {
  return yup.string().email(`${name} is invalid.`).required('Email is required.');
};
